import { render, staticRenderFns } from "./PostMessgae.vue?vue&type=template&id=5e98b1e6"
import script from "./PostMessgae.vue?vue&type=script&lang=js"
export * from "./PostMessgae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports